import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { AvailableReportsSection } from "@/components/reporting/sections/AvailableReportsSection";
import { ReportMetadataSection } from "@/components/reporting/sections/ReportMetadataSection";

export function ReportsPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Reports
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Backend-reported report models only — no downloads or exports.
        </Typography>
      </Box>
      <Stack spacing={3}>
        <AvailableReportsSection />
        <ReportMetadataSection />
      </Stack>
    </ResponsiveContainer>
  );
}
